import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_ROUTES } from "../../constants/apiRoutes";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${API_ROUTES}Password/forgot`,
        { email }
        // {
        //   headers: {
        //     Authorization: `Bearer ${token}`,
        //   },
        // }
      );
      // const config = {
      //   method: "POST",
      //   maxBodyLength: Infinity,
      //   url: `${API_ROUTES}Password/forgot`,
      //   //   headers: {
      //   //     Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
      //   //   },
      // };

      // axios
      //   .request(config)
      //   .then((response) => {
      //     //   setWsdata(response.data);
      //     setMessage("OTP sent to your email.");
      //     setError("");
      //     setTimeout(() => navigate("/verify-otp"), 2000);
      //   })
      //   .catch((error) => {
      //     setError("Error sending OTP. Please try again.");
      //     setMessage("");
      //   });
      setMessage("OTP sent to your email.");
      setError("");
      // Redirect to OTP verification page
      setTimeout(() => navigate("/verify-otp"), 2000);
    } catch (error) {
      console.error("Error sending OTP", error);
      setError("Error sending OTP. Please try again.");
      setMessage("");
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-base-200">
      <div className="w-full max-w-md p-8 space-y-4  shadow-lg rounded-lg">
        <h2 className="text-2xl font-bold text-center">Forgot Password</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="form-control">
            <label className="label" htmlFor="email">
              <span className="label-text">Email</span>
            </label>
            <input
              type="email"
              id="email"
              className="input input-bordered w-full"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary w-full">
            Submit
          </button>
          {message && (
            <div className="text-green-500 text-center mt-4">{message}</div>
          )}
          {error && (
            <div className="text-red-500 text-center mt-4">{error}</div>
          )}
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
